import { combineEpics } from 'redux-observable';

// services
import { Service as AnalyticsService } from 'modules/analytics-provider';

// epics
import {
    analyticsEpicCreator,
    setLanguage,
    setUserAnalyticsData,
    cleanLoginAnalyticsData,
    mainPage
} from 'modules/analytics-provider/analytics-provider.epic';

// constants
import { REPORT_ANALYTICS_LANGUAGE_AND_COUNTRY } from 'modules/language-provider/language-provider.constants';
import { REMOVE_LOGIN_SESSION, SET_LOGIN_SESSION } from 'modules/login/login.constants';
import { Analytics } from './analytics';
import { OPTION_LANGUAGE_ANALYTICS_ATTRIBUTES } from 'modules/footer/footer.constants';
import {
    STEP_INVITATION_PAGE,
    STEP_ERROR,
    STEP_INVITEE_PAGE,
    STEP_ERROR_NOT_ELIGIBLE,
    STEP_ERROR_STATUS,
    STEP_REFERRAL_DASHBOARD
} from '../../router/router.constants';
import { WIDGET_ACTIVE_VIEW_TRANSITION } from 'modules/router/router.constants';
import { INITIALIZE_UBISOFT_CONNECT_DONE } from 'modules/ubisoft-connect-provider/ubisoft-connect-provider.constants';

// types
import { IAction } from 'types/action';
import { IEpic } from 'types/epic';

export const mainPageEpic = mainPage([INITIALIZE_UBISOFT_CONNECT_DONE, REMOVE_LOGIN_SESSION], Analytics.Constants);
export const setLanguageEpic = setLanguage([REPORT_ANALYTICS_LANGUAGE_AND_COUNTRY], OPTION_LANGUAGE_ANALYTICS_ATTRIBUTES);
const setUserAnalyticsDataEpic = setUserAnalyticsData([SET_LOGIN_SESSION]);
const cleanLoginAnalyticsDataEpic = cleanLoginAnalyticsData([REMOVE_LOGIN_SESSION]);

export const analyticPageEpic = analyticsEpicCreator(
    [WIDGET_ACTIVE_VIEW_TRANSITION],
    (action: IAction, _store): void => {
        switch (action.payload) {
        case STEP_INVITEE_PAGE : {
            AnalyticsService.sendPageEvent({
                pageName: Analytics.Constants.inviteePage.name,
                siteSubSection: Analytics.Constants.inviteePage.subSection,
                errorType: ''
            });
            break;
        }
        case STEP_REFERRAL_DASHBOARD : {
            AnalyticsService.sendPageEvent({
                pageName: Analytics.Constants.referralPage.name,
                siteSubSection: Analytics.Constants.referralPage.subSection,
                errorType: ''
            });
            break;
        }
        case STEP_INVITATION_PAGE : {
            AnalyticsService.sendPageEvent({
                pageName: Analytics.Constants.invitationPage.name,
                siteSubSection: Analytics.Constants.invitationPage.subSection,
                errorType: ''
            });
            break;
        }
        case STEP_ERROR : {
            AnalyticsService.sendPageEvent({
                pageName: Analytics.Constants.errorPage.name,
                siteSubSection: Analytics.Constants.errorPage.subSection
            });
            break;
        }
        case STEP_ERROR_STATUS :
        case STEP_ERROR_NOT_ELIGIBLE : {
            AnalyticsService.sendPageEvent({
                pageName: Analytics.Constants.apiErrorPage.name,
                siteSubSection: Analytics.Constants.apiErrorPage.subSection
            });
            break;
        }
        default:
            break;
        }
    }
);

/** Below epic was added for Friends Referral flow specifically.
 * Its purpose is automatically to opt-in cookies policy banner,
 * as it may be accepted elsewhere (in Ubisoft Connect for example).
 * So we consider successful login as the acceptance of cookies policy.
 */
const analyticsTriggerOptIn = analyticsEpicCreator([SET_LOGIN_SESSION], AnalyticsService.triggerOptIn);

export const analyticsEpics: IEpic = combineEpics(
    analyticsTriggerOptIn,
    mainPageEpic,
    setLanguageEpic,
    setUserAnalyticsDataEpic,
    cleanLoginAnalyticsDataEpic,
    analyticPageEpic,
);

export default analyticsEpics;
